// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"cb43d290","990":"e8931867"}[chunkId] + ".chunk.css";
};